var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Introduce'),_c('Categories'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backlog"},[_c('a',{staticStyle:{"color":"rgba(0, 0, 0, 0.65)"},attrs:{"href":"/wiki"}},[_c('p',[_vm._v("返回旧版")])])])
}]

export { render, staticRenderFns }